app
  .controller("SliderPlaylistController", [
    "$scope",
    "getSiteDetails",
    function ($scope, getSiteDetails) {
      $scope.title = $scope.payload.title;
      $scope.description = $scope.payload.description;
      if ($scope.payload) {
        getSiteDetails
          .getPlaylistContent($scope.payload.playlistID)
          .then((result) => {
            $scope.elementContent = result.content[0];
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  ])
  .directive("contentSliderPlaylist", [
    function () {
      return {
        restrict: "AE",
        transclude: true,
        scope: {
          payload: "=",
        },
        templateUrl: "template/elements/contentSliderPlaylist.html",
      };
    },
  ]);
